// Renders a string with the brand token "Art Lens" (or legacy "ARTLENSS") highlighted in the accent color.
export const HighlightBrand = ({ text, className = "" }) => {
  if (!text) return null;
  const parts = text.split(/(Art Lens|ARTLENSS)/g);
  return (
    <span className={className}>
      {parts.map((p, i) =>
        p === "Art Lens" || p === "ARTLENSS" ? (
          <span key={i} className="text-[#E6A95B] font-semibold tracking-tight">
            Art Lens
          </span>
        ) : (
          <span key={i}>{p}</span>
        )
      )}
    </span>
  );
};

export default HighlightBrand;
